import { oidcEarlyInit } from 'oidc-spa/entrypoint';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { createAppConfig } from './app/app.config';
import { environment as fallbackEnv } from './environments/environment';


const { shouldLoadApp } = oidcEarlyInit({ BASE_URL: '/' });

if (shouldLoadApp) {
  fetch('assets/config/env.json')
    .then(r => r.json())
    .catch(() => fallbackEnv)
    .then(env => bootstrapApplication(AppComponent, createAppConfig(env)))
    .catch(err => console.error(err));
}
